const errors = new Map<string, unknown>();

export const jobErrorStore = {
  set(jobId: string, error: unknown) {
    errors.delete(jobId);
    errors.set(jobId, error);
  },

  get<T>(jobId: string): T | undefined {
    return errors.get(jobId) as T | undefined;
  },

  clear(jobId: string) {
    errors.delete(jobId);
  },
};
